/**
 * Insights listing — load more.
 */

const insightsLoadMore = () => {
	const grid = document.querySelector( '[data-insights-grid]' )
	const btn = document.querySelector( '[data-insights-loadmore]' )

	if ( ! grid || ! btn || typeof ajaxObject === 'undefined' ) {
		return
	}

	btn.addEventListener( 'click', async () => {
		if ( btn.disabled || btn.classList.contains( 'is-loading' ) ) {
			return
		}

		const offset = Number( grid.getAttribute( 'data-offset' ) || 0 )
		const perPage = Number( grid.getAttribute( 'data-per-page' ) || 15 )
		const exclude = Number( grid.getAttribute( 'data-exclude' ) || 0 )
		const category = grid.getAttribute( 'data-category' ) || ''
		const format = grid.getAttribute( 'data-format' ) || ''

		btn.classList.add( 'is-loading' )
		btn.disabled = true

		const body = new FormData()
		body.append( 'action', 'alquity_insight_load_more' )
		body.append( 'nonce', ajaxObject.ajax_nonce )
		body.append( 'offset', String( offset ) )
		body.append( 'per_page', String( perPage ) )
		body.append( 'exclude', String( exclude ) )
		body.append( 'category', category )
		body.append( 'format', format )

		try {
			const res = await fetch( ajaxObject.ajax_url, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			} )
			const json = await res.json()

			if ( ! json || ! json.success || ! json.data ) {
				throw new Error( 'Load more failed' )
			}

			const { html, offset: nextOffset, has_more: hasMore } = json.data

			if ( html ) {
				grid.insertAdjacentHTML( 'beforeend', html )
			}

			grid.setAttribute( 'data-offset', String( nextOffset ) )

			if ( ! hasMore ) {
				const wrap = btn.closest( '.insights-loadmore' )
				if ( wrap ) {
					wrap.remove()
				} else {
					btn.remove()
				}
				return
			}

			btn.classList.remove( 'is-loading' )
			btn.disabled = false
		} catch ( err ) {
			btn.classList.remove( 'is-loading' )
			btn.disabled = false
		}
	} )
}

export { insightsLoadMore }
